// @flow strict

import { Button, Modal, Table, Tag, message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { deleteCoupon, getCoupons } from "../../../../api/pricing";
import NewCoupon from "./NewCoupon";

function Coupons() {
  const [coupons, setCoupons] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const navigate = useNavigate();

  const handleClickDelete = (id) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this coupon?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => handleDeleteCoupon(id),
    });
  };

  const handleDeleteCoupon = async (id) => {
    try {
      const res = await deleteCoupon(id);
      console.log(res)
      message.success(res.data?.message);
      navigate(0);
    } catch (error) {
      console.log(error);
      message.error(error?.message);
    }
  };

  const fetchCoupon = async () => {
    try {
      const res = await getCoupons();

      if (res.data?.coupons) {
        setCoupons(res.data?.coupons);
      };
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: <p className="text-center my-0">Code</p>,
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: <p className="text-center my-0">Percent Off</p>,
      dataIndex: 'percent_off',
      key: 'percent_off',
      render: (percent_off) => (
        <p className="text-center my-0 font-text-bold">{percent_off}%</p>
      ),
    },
    {
      title: <p className="text-center my-0">Type</p>,
      key: 'duration',
      dataIndex: 'duration',
      render: (type) => (
        <Tag color="cyan">
          {type}
        </Tag>
      ),
    },
    {
      title: <p className="text-center my-0">Expire Date</p>,
      key: 'expires_at',
      dataIndex: 'expires_at',
      render: (date) => (
        <p className="text-center my-0">
          {
            !date ? (
              <Tag color="green">Never</Tag>
            ) :
              new Date() > new Date(date) ? (
                <Tag color="red">Expired</Tag>
              ) : (
                <Tag color="blue">
                  {new Date(date).toLocaleDateString()}
                </Tag>
              )
          }
        </p>
      ),
    },
    {
      title: <p className="text-center my-0">Actions</p>,
      render: (_, coupon) => (
        <Button onClick={() => handleClickDelete(coupon._id)} danger size="small">
          Delete
        </Button>
      )
    }
  ];

  useEffect(() => {
    fetchCoupon();
  }, []);

  return (
    <div className="">
      <Table
        title={() => (
          <div className="d-flex justify-content-between align-items-center">
            <h3>Coupon List</h3>
            <Button onClick={() => setAddModal(true)}>+ New</Button>
          </div>
        )}
        bordered
        dataSource={coupons}
        columns={columns}
        scroll={{ x: true }}
      />
      <Modal
        title="Create New Coupon"
        open={addModal}
        onCancel={() => setAddModal(false)}
        footer={[]}
      >
        <NewCoupon setAddModal={setAddModal} />
      </Modal>
    </div>
  );
};

export default Coupons;